import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import "@fontsource/inter";
import "./App.css";
import axios from "axios";
import FilterByAssistant from "./Components/FilterByAssistant";
import LoadingOverlay from "./Components/spinner";

const SMSDashboard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({
    key: "created_at",
    direction: "descending",
  });
  const [modalContent, setModalContent] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clientId, setClientId] = useState(null);
  const [clientLocation, setClientLocation] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [isSummary, setIsSummary] = useState(false); // Track if it's a summary or transcript
  const [token, setToken] = useState(null); //added to make the token accessible to other
  // Fetching client data from URL params
  useEffect(() => {
    const fetchClientData = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const ghlDashboardToken = urlParams.get("token"); // Get token from the URL
      setToken(ghlDashboardToken);
      // Fetch client data using the token
      const { data: clientData, error: clientError } = await supabase
        .from("Clients")
        .select("id, ghl_location_id, location")
        .eq("ghl_dashboard_token", ghlDashboardToken) // Correctly applying the filter
        .single();
      if (clientError) {
        console.error("Error fetching client data:", clientError);
      } else {
        const clientId = clientData.id;
        const clientLocation = clientData.location;
        setClientId(clientId); // Store clientId for use in subsequent smss
        setClientLocation(clientLocation);
      }
    };

    fetchClientData();
  }, []); // Empty dependency array to run on mount only

  const handleQuickDateSelect = (range) => {
    const timeZone = "Australia/Sydney";
    const now = new Date();
    let startDate, endDate;

    // Sydney timezone offset (Adjust for DST if needed)
    const sydneyOffset = now.getTimezoneOffset() / -60; // Will be 11 or 10

    if (range === "today") {
      const options = {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      const formatter = new Intl.DateTimeFormat("en-CA", options); // Using en-CA to ensure YYYY-MM-DD format

      const [{ value: year }, , { value: month }, , { value: day }] =
        formatter.formatToParts(now);

      // Create start and end dates in Sydney timezone
      const start = new Date(`${year}-${month}-${day}T00:00:00.000Z`);
      const end = new Date(`${year}-${month}-${day}T23:59:59.999Z`);
      console.log(start, end);
      startDate = new Date(start).toISOString().split("T")[0];
      endDate = new Date(end).toISOString().split("T")[0];
    } else if (range === "thisWeek") {
      // Get current day in Sydney time
      const sydneyNow = new Date(now.getTime() + sydneyOffset * 60 * 60 * 1000);
      const dayOfWeek = sydneyNow.getDay(); // 0 = Sunday, 1 = Monday, etc.

      // Get start of the week (Monday in Sydney time)
      const diffToMonday = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek;
      const sydneyStartOfWeek = new Date(sydneyNow);
      sydneyStartOfWeek.setDate(sydneyNow.getDate() + diffToMonday);
      sydneyStartOfWeek.setHours(0, 0, 0, 0);

      // Convert to UTC
      const startOfWeekUTC = new Date(
        sydneyStartOfWeek.getTime() - sydneyOffset * 60 * 60 * 1000
      );
      startDate = startOfWeekUTC.toISOString().split("T")[0];

      // End of the week (Sunday 23:59 Sydney time)
      const sydneyEndOfWeek = new Date(sydneyStartOfWeek);
      sydneyEndOfWeek.setDate(sydneyStartOfWeek.getDate() + 6);
      sydneyEndOfWeek.setHours(23, 59, 59, 999);

      const endOfWeekUTC = new Date(
        sydneyEndOfWeek.getTime() - sydneyOffset * 60 * 60 * 1000
      );
      endDate = endOfWeekUTC.toISOString().split("T")[0];
    } else if (range === "thisMonth") {
      const options = { timeZone, year: "numeric", month: "2-digit" };
      const formatter = new Intl.DateTimeFormat("en-CA", options); // Using en-CA to ensure YYYY-MM-DD format

      const [{ value: year }, , { value: month }] =
        formatter.formatToParts(now);

      // Create start and end dates for the current month
      const start = new Date(`${year}-${month}-01T00:00:00.000Z`);
      const end = new Date(start);
      end.setMonth(end.getMonth() + 1);
      end.setDate(0); // Set to last day of previous month (i.e., last day of current month)
      end.setHours(23, 59, 59, 999);
      startDate = new Date(start).toISOString().split("T")[0];
      endDate = new Date(end).toISOString().split("T")[0];
    }

    // // Sydney timezone offset (Adjust for DST if needed)
    // const sydneyOffset = now.getTimezoneOffset() / -60; // Will be 11 or 10

    // if (range === "today") {
    //   // Convert Sydney midnight to UTC
    //   const sydneyMidnight = new Date(now);
    //   sydneyMidnight.setHours(0, 0, 0, 0); // Set to start of the day in Sydney

    //   // Convert Sydney start to UTC
    //   const startOfDayUTC = new Date(
    //     sydneyMidnight.getTime() - sydneyOffset * 60 * 60 * 1000
    //   );

    //   startDate = startOfDayUTC.toISOString().split("T")[0];

    //   // End of today is just before Sydney's midnight (23:59:59)
    //   const endOfDayUTC = new Date(
    //     sydneyMidnight.getTime() + (24 - sydneyOffset) * 60 * 60 * 1000 - 1
    //   );
    //   endDate = endOfDayUTC.toISOString().split("T")[0];
    // } else if (range === "thisWeek") {
    //   // Get current day in Sydney time
    //   const sydneyNow = new Date(now.getTime() + sydneyOffset * 60 * 60 * 1000);
    //   const dayOfWeek = sydneyNow.getDay(); // 0 = Sunday, 1 = Monday, etc.

    //   // Get start of the week (Monday in Sydney time)
    //   const diffToMonday = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek;
    //   const sydneyStartOfWeek = new Date(sydneyNow);
    //   sydneyStartOfWeek.setDate(sydneyNow.getDate() + diffToMonday);
    //   sydneyStartOfWeek.setHours(0, 0, 0, 0);

    //   // Convert to UTC
    //   const startOfWeekUTC = new Date(
    //     sydneyStartOfWeek.getTime() - sydneyOffset * 60 * 60 * 1000
    //   );
    //   startDate = startOfWeekUTC.toISOString().split("T")[0];

    //   // End of the week (Sunday 23:59 Sydney time)
    //   const sydneyEndOfWeek = new Date(sydneyStartOfWeek);
    //   sydneyEndOfWeek.setDate(sydneyStartOfWeek.getDate() + 6);
    //   sydneyEndOfWeek.setHours(23, 59, 59, 999);

    //   const endOfWeekUTC = new Date(
    //     sydneyEndOfWeek.getTime() - sydneyOffset * 60 * 60 * 1000
    //   );
    //   endDate = endOfWeekUTC.toISOString().split("T")[0];
    // }

    setStartDate(startDate);
    setEndDate(endDate);
  };

  // Clear quick select buttons
  const clearFilters = () => {
    setSearchTerm("");
    setStartDate("");
    setEndDate("");
  };

  // State for search term and date range
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Fetching smss data
  useEffect(() => {
    const fetchData = async () => {
      if (!clientId) return; // Don't fetch smss until clientId is available

      const { data: smss, error } = await supabase
        .from("SMS")
        .select("*")
        .eq("client_id", clientId) // Ensure you're filtering smss for the specific client
        .order("created_at", { ascending: false }); // Sort smss by created_at descending
      if (error) {
        console.error("Error fetching sms:", error);
      } else {
        // Fetch client data (ghl_location_id) for each sms
        const enrichedCalls = await Promise.all(
          //refactored this code for a more faster load time
          smss.map(async (sms) => {
            let duration = 0;
            console.log(sms);
            let costs = (sms?.costs || [])[0] || [];
            for (let i = 0; i < costs.length; i++) {
              const cost = costs[i];
              sms[cost.type + "_cost_breakdown"] = cost;
            }
            return {
              ...sms,
              duration,
              ghl_location_id: token || null,
            };
          })
        );

        setData(enrichedCalls); // Set the enriched data to state
      }

      setLoading(false); // Stop loading after data is fetched
    };

    fetchData();
  }, [clientId]); // Only run fetchData when clientId is set

  // Parse the conversation
  const parseConversation = (transcription) => {
    const messages = [];

    // Split by "User:" or "AI:"
    const splitMessages = transcription.split(/(?=User:|AI:)/);

    // Process each message
    splitMessages.forEach((message) => {
      if (message.startsWith("User:")) {
        messages.push({
          sender: "User",
          text: message.replace("User:", "").trim(),
        });
      } else if (message.startsWith("AI:")) {
        messages.push({
          sender: "AI",
          text: message.replace("AI:", "").trim(),
        });
      }
    });

    return messages;
  };

  // Sorting function with arrows
  const handleSort = (key, type) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === "ascending"
        ? "descending"
        : "ascending";
    setSortConfig({ key, direction });

    const sortedData = [...data].sort((a, b) => {
      const valA = a[key] || (type === "string" ? "" : 0);
      const valB = b[key] || (type === "string" ? "" : 0);

      if (type === "date") {
        return direction === "ascending"
          ? new Date(valA) - new Date(valB)
          : new Date(valB) - new Date(valA);
      }
      if (type === "string") {
        return direction === "ascending"
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }
      return direction === "ascending" ? valA - valB : valB - valA;
    });

    setData(sortedData);
  };

  // Handle search input
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  // --new--
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedFilter, startDate, endDate]);
  // --end--
  // Filtered data based on search and date range
  const filteredData = data.filter((sms) => {
    const direction = sms.direction ? sms.direction.toLowerCase() : "";
    const FromNumber = sms.from ? sms.from.toLowerCase() : "";
    const ToNumber = sms.to ? sms.to.toLowerCase() : "";
    const matchesSearchTerm =
      direction.includes(searchTerm.toLowerCase()) ||
      ToNumber.includes(searchTerm.toLowerCase()) ||
      FromNumber.includes(searchTerm.toLowerCase());
    // console.log(
    //   new Date(sms.created_at).toLocaleString("en-AU", {
    //     timeZone: "Australia/Sydney",
    //   }),
    //   new Date(startDate).setHours(0, 0, 0, 0),
    //   new Date(endDate).setHours(23, 59, 59, 999)
    // );
    const matchesDateRange =
      (!startDate ||
        new Date(sms.created_at) >= new Date(startDate).setHours(0, 0, 0, 0)) &&
      (!endDate ||
        new Date(sms.created_at) <=
          new Date(endDate).setHours(23, 59, 59, 999));

    const matchesAssistant =
      selectedFilter === "All" ||
      (selectedFilter === "Rec" && sms.assistant === "Receptionist") ||
      (selectedFilter === "Inst" && sms.assistant === "Instant Follow Up");

    return matchesSearchTerm && matchesDateRange && matchesAssistant;
  });

  // Function to open modal with content based on type (transcript or summary)
  const openModal = (content, customerName, isSummary = false) => {
    // Only open modal if content is not empty
    if (content && content.trim()) {
      setCustomerName(customerName); // Store the customer name
      setIsModalOpen(true); // Open modal
      setIsSummary(isSummary); // Set whether the content is a summary or not
      setModalContent(content.replace(/\\n/g, "\n")); // Handle content formatting
    }
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
    setCustomerName(""); // Clear the customer name when closing the modal
  };

  // Handle page change
  const handlePageChange = (direction) => {
    if (direction === "next") {
      setCurrentPage((prevPage) => prevPage + 1);
    } else if (direction === "prev" && currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  // Calculate the current page data
  const currentPageData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const [updatingFollowUp, setUpdatingFollowUp] = useState(false);
  const followUpCall = async (sms_id = "", checked = false) => {
    console.log(sms_id, checked);
    if (!sms_id) return;
    setUpdatingFollowUp(true);
    // https://automations.creativedigital.ai/webhook-test/followup
    const headers = {
      "Content-Type": "application/json",
    };
    const response = await axios.post(
      "https://automations.creativedigital.ai/webhook/followup",
      {
        sms_id,
        followed_up: checked,
      },
      {
        headers: headers,
      }
    );
    if (response.status == 200) {
      let list = [...data];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (sms_id == item.id) {
          item.followed_up = checked;
          break;
        }
      }
      setUpdatingFollowUp(false);
    } else {
      setUpdatingFollowUp(false);
    }
  };
  return (
    <div className="App">
      <h1>SMS Dashboard {clientLocation && `- ${clientLocation}`}</h1>

      {/* Parent container for both Quick Select and Filters */}
      <div className="top-container">
        {/* Quick Date Select Links */}
        <div className="quick-date-select">
          <span onClick={() => handleQuickDateSelect("today")}>Today</span>
          <span onClick={() => handleQuickDateSelect("thisWeek")}>
            This Week
          </span>
          <span onClick={() => handleQuickDateSelect("thisMonth")}>
            This Month
          </span>

          {/* Clear Filters Button */}
          <span onClick={clearFilters}>All</span>
        </div>

        {/* Search and Date Range Filters */}
        <div className="filters">
          <input
            type="text"
            className="search-input"
            placeholder="Search by name or phone number"
            value={searchTerm}
            onChange={handleSearchChange}
          />
          {/* <FilterByAssistant
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
          /> */}
          <div className="date-range">
            <input
              type="date"
              className="date-range-input"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <input
              type="date"
              className="date-range-input"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>
      </div>
      <LoadingOverlay isLoading={updatingFollowUp} />
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="table-container">
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th onClick={() => handleSort("created_at", "date")}>
                    Date{" "}
                    {sortConfig.key === "created_at" &&
                      (sortConfig.direction === "descending" ? "↓" : "↑")}
                  </th>

                  <th>From</th>
                  <th>To</th>
                  <th>Body</th>
                  <th>Direction</th>
                  <th>Number of Segments</th>
                </tr>
              </thead>
              <tbody>
                {currentPageData.map((sms) => (
                  <tr key={sms.id}>
                    <td className="start-date-column">
                      {new Date(sms.created_at).toLocaleString("en-AU", {
                        timeZone: "Australia/Sydney",
                      })}
                    </td>
                    <td>{sms.from}</td>
                    <td>{sms.to}</td>
                    <td className="summary-column">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: sms.body.replace(/\n/g, "<br>"),
                        }}
                      />{" "}
                      <br></br>
                      <button
                        onClick={() =>
                          openModal(
                            sms.body.replace(/\n/g, "<br>"),
                            sms.customer_name,
                            true
                          )
                        }
                      >
                        See All
                      </button>
                    </td>
                    <td>
                      {sms.direction == "inbound"
                        ? "Inbound"
                        : sms.direction == "outbound-api"
                        ? "Outbound"
                        : ""}
                    </td>
                    <td>{sms.num_segments}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {isModalOpen && (
        <div className="modal" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()} // Prevent background click from closing modal
          >
            <div className="modal-header">
              <span className="close-button" onClick={closeModal}>
                &times;
              </span>
              {/* Dynamismsy set the title based on isSummary */}
              <h2>{isSummary ? "SMS Body" : "Transcript"}</h2>
            </div>
            {/* Modal Body with Chat */}
            <div className="modal-body">
              <div className="chat-container">
                {/* Render either summary or transcript */}
                {isSummary ? (
                  <div className="summary-content">
                    <div
                      className="summary-text sms-body"
                      dangerouslySetInnerHTML={{
                        __html: modalContent, // Ensure modalContent is HTML formatted
                      }}
                    />
                  </div>
                ) : (
                  parseConversation(modalContent).map((message, index) => (
                    <div
                      key={index}
                      className={`chat-message ${
                        message.sender === "User"
                          ? "user-message"
                          : "ai-message"
                      }`}
                    >
                      <div className="message-text">{message.text}</div>
                      <div
                        className={`message-label ${
                          message.sender === "User" ? "user-label" : "ai-label"
                        }`}
                      >
                        {message.sender}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Results per page dropdown */}

      <div className="top-container">
        <div className="results-per-page">
          <label htmlFor="itemsPerPage">Results per page: </label>
          <select
            id="itemsPerPage"
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(Number(e.target.value))}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
        </div>

        {/* Calls Counter */}
        <div className="smss-counter">
          <p>{filteredData.length} Calls Found</p>
        </div>
      </div>

      {/* Pagination */}
      <div className="pagination">
        <button
          onClick={() => handlePageChange("prev")}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>
          {currentPage === 1
            ? `Page ${currentPage}`
            : `Page ${currentPage} of ${Math.ceil(
                filteredData.length / itemsPerPage
              )}`}
        </span>
        <button
          onClick={() => handlePageChange("next")}
          disabled={
            currentPage >= Math.ceil(filteredData.length / itemsPerPage)
          }
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default SMSDashboard;
